'use client'

import Link from 'next/link'
import { useState } from 'react'

export default function BlogNav() {
  const [mobileOpen, setMobileOpen] = useState(false)

  return (
    <header className="border-b border-white/10 bg-background/80 backdrop-blur-md sticky top-0 z-50">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 py-4 flex items-center justify-between">
        <div className="flex items-center gap-8">
          <Link href="/" className="text-lg font-bold text-white hover:text-gray-300 transition-colors">
            AI Builder Club
          </Link>
          <nav className="hidden sm:flex items-center gap-6 text-sm">
            <Link href="/blog" className="text-white font-medium">Blog</Link>
            <Link href="/courses" className="text-gray-400 hover:text-white transition-colors">Courses</Link>
            <Link
              href="https://www.youtube.com/@AIJasonZ"
              target="_blank"
              rel="noopener noreferrer"
              className="text-gray-400 hover:text-white transition-colors"
            >
              YouTube
            </Link>
          </nav>
        </div>

        <div className="hidden sm:block">
          <Link
            href="#newsletter"
            className="bg-white text-black font-semibold px-5 py-2 rounded-full text-sm hover:bg-gray-200 transition-colors"
          >
            Subscribe
          </Link>
        </div>

        <button
          className="sm:hidden text-white p-1"
          onClick={() => setMobileOpen(!mobileOpen)}
          aria-label="Toggle menu"
        >
          {mobileOpen ? (
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          ) : (
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
            </svg>
          )}
        </button>
      </div>

      {mobileOpen && (
        <div className="sm:hidden border-t border-white/10 bg-background px-4 py-4 space-y-3">
          <Link href="/blog" className="block text-white font-medium text-sm" onClick={() => setMobileOpen(false)}>Blog</Link>
          <Link href="/courses" className="block text-gray-400 text-sm" onClick={() => setMobileOpen(false)}>Courses</Link>
          <Link
            href="https://www.youtube.com/@AIJasonZ"
            target="_blank"
            rel="noopener noreferrer"
            className="block text-gray-400 text-sm"
          >
            YouTube
          </Link>
          <Link
            href="#newsletter"
            className="inline-block bg-white text-black font-semibold px-5 py-2 rounded-full text-sm mt-2"
            onClick={() => setMobileOpen(false)}
          >
            Subscribe
          </Link>
        </div>
      )}
    </header>
  )
}
